import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/agents/id/sharing/page';

export const Route = createFileRoute('/_app/_chat/agents/$id/sharing/')({
  component: Page,
});
